import apiCall from "../../axios";

export interface AxisTalkdownSupportCamera {
  CameraId: string;
  VendorCameraId?: string;
}

export interface AxisTalkdownSupportRequest {
  AipxToken: string;
  Cameras: AxisTalkdownSupportCamera[];
}

export interface AxisTalkdownSupportResponse {
  cameraSupport?: Record<string, boolean>;
  success?: boolean;
  message?: string;}

const getAxisTalkdownCameraSpeakerSupport = async (
  body: AxisTalkdownSupportRequest
): Promise<AxisTalkdownSupportResponse> => {
  try {
    const response = await apiCall(
      "POST",
      "/axiscloudconnect/talkdown/camera-speaker-support",
      body
    );

    return (response.data?.data ?? response.data) as AxisTalkdownSupportResponse;
  } catch (error: any) {
    console.error("getAxisTalkdownCameraSpeakerSupport (AxisCloudConnect) Error:", error?.message);
    return {
      success: false,
      message: error?.message || "Failed to resolve Axis Cloud Connect talkdown camera support.",
      cameraSupport: {},
    };
  }
};

export default getAxisTalkdownCameraSpeakerSupport;
